import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PaginationService } from './pagination.service';
import { PaginatedResponse } from '../models/paginations/paginated-response.model';
import { ApiResponse } from '../models/api-response/api-response.model';
import { TodoForCreation } from '../models/todos/todo-for-creation.model';
import { TodoForListing } from '../models/todos/todo-for-listing.model';
import { TodoForUpdation } from '../models/todos/todo-for-updation.model';
import { TodoDateForUpdation } from '../models/todos/todo-date-for-updation.model';
import { TodoIsCompletedForUpdation } from '../models/todos/todo-is-completed-for-updation.model';
import { TodoDto } from '../models/todos/todo.model';
import { TodoRequestFilter } from '../models/todos/todo-request-filter.model';

@Injectable({
  providedIn: 'root'
})
export class TodoService {
  private apiUrl = `${environment.apiUrl}/todo`;

  constructor(private http: HttpClient, private paginationService: PaginationService) { }

  getPaginatedTodos(filter: TodoRequestFilter): Observable<PaginatedResponse<TodoForListing>> {
    return this.paginationService.getPaginatedData<TodoForListing>(this.apiUrl, filter);
  }

  getTodoById(id: number): Observable<TodoDto> {
    return this.http.get<TodoDto>(`${this.apiUrl}/${id}`);
  }

  createTodo(data: TodoForCreation): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.apiUrl, data);
  }

  updateTodo(data: TodoForUpdation): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(this.apiUrl, data);
  }

  softDeleteTodo(id: number): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(`${this.apiUrl}/soft/${id}`);
  }

  updateTodoDate(data: TodoDateForUpdation): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`${this.apiUrl}/date`, data);
  }

  markTodoAsCompleted(todoId: number): Observable<ApiResponse> {
    const data: TodoIsCompletedForUpdation = {
      todoId: todoId,
      isCompleted: true
    };
    return this.http.put<ApiResponse>(`${this.apiUrl}/mark-unmark-as-completed`, data);
  }

  unmarkTodoAsCompleted(todoId: number): Observable<ApiResponse> {
    const data: TodoIsCompletedForUpdation = {
      todoId: todoId,
      isCompleted: false
    };
    return this.http.put<ApiResponse>(`${this.apiUrl}/mark-unmark-as-completed`, data);
  }
}
